// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__23bcu","active":"NavigationItem__active__2zJdO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 100
// module chunks = 3